import type { CmsEventTeaser } from '@/components/CmsInterfaces';
import LinkWrapper from '@/components/LinkWrapper';
import classnames from '@/utilities/classnames';
import scaleImage from '@/utilities/scaleImage';
import Image from 'next/image';
import React from 'react';

export const HomeEventTeaser: React.FC<
  React.PropsWithChildren<CmsEventTeaser>
> = (props) => {
  // Existiert der linkTitle wird der "neue" Teaserstyle verwendet
  const { title, link, linkTitle, imageDesktop, imageMobile } = props;

  return (
    <LinkWrapper
      className={classnames('HomeEventTeaser', {
        'HomeEventTeaser--overlayText': linkTitle,
      })}
      href={link}
      title={title}
    >
      <picture style={{ width: '100%', height: 'auto' }}>
        <source
          media="(min-width: 882px)"
          srcSet={
            linkTitle
              ? imageDesktop
              : scaleImage({ url: imageDesktop, width: 600, quality: 50 })
          }
        />
        <Image
          alt={title}
          className="HomeEventTeaser__image"
          priority={false}
          src={
            linkTitle
              ? imageMobile
              : scaleImage({ url: imageMobile, width: 600, quality: 50 })
          }
          width={0}
          height={0}
          sizes="100vw"
        />
      </picture>
      {linkTitle && (
        <>
          <strong className="HomeEventTeaser__title">{title}</strong>
          <span className="HomeEventTeaser__text">{linkTitle}</span>
        </>
      )}
    </LinkWrapper>
  );
};
